// extracted by mini-css-extract-plugin
module.exports = {"flex":"DisplayBanner_flex__3cuIH","message":"DisplayBanner_message__3wbyj"};